
// src/pages/ProfileGate/steps/OrientationStep.jsx

import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";

import ProfileGateShell from "../../../components/profile-gate/ProfileGateShell";

const ORIENTATION_VIDEO_URL =
  "https://kwbgrjakobarqelunebd.supabase.co/storage/v1/object/public/pictures/MVP4/Onboarding/Orientation%20Screens_v20260929.mp4";

const BACKGROUND_PENGUIN_URL =
  "https://kwbgrjakobarqelunebd.supabase.co/storage/v1/object/public/pictures/MVP4/Public%20Pages/Landing/gwin-penguin.png";

export default function OrientationStep() {
  const navigate = useNavigate();
  const videoRef = useRef(null);

  function handleWatchAgain() {
    const video = videoRef.current;

    if (!video) return;

    video.currentTime = 0;

    const playPromise = video.play();

    if (playPromise?.catch) {
      playPromise.catch(() => {});
    }
  }

  function handleNext() {
    navigate("/profile-gate/onboarding-complete");
  }

  return (
    <ProfileGateShell
      title=""
      subtitle=""
      progress={null}
      progressPercent={null}
      showBack={true}
      backLabel="Watch again"
      onBack={handleWatchAgain}
      nextLabel="Continue"
      onNext={handleNext}
    >
      <div
        className="
          mx-auto flex min-h-[calc(100dvh-225px)]
          w-full items-center justify-center
          overflow-visible px-2 py-4
          xs:px-3 xs:py-5
          sm:px-5 sm:py-6
          md:px-6 md:py-7
          lg:px-8 lg:py-8
        "
      >
        <div
          className="
            relative flex items-center justify-center
            w-[86vw] max-w-[330px]
            xs:w-[84vw] xs:max-w-[345px]
            sm:w-[72vw] sm:max-w-[380px]
            md:w-[56vw] md:max-w-[420px]
            lg:w-[44vw] lg:max-w-[460px]
            xl:w-[38vw] xl:max-w-[500px]
          "
        >
          {/* Top-right penguin */}
          <img
            src={BACKGROUND_PENGUIN_URL}
            alt=""
            aria-hidden="true"
            className="
              pointer-events-none absolute z-0
              top-[10%] right-[1%]
              w-[29%] min-w-[70px] max-w-[145px]
              translate-x-[48%] rotate-[-59deg] opacity-50
              xs:top-[11%] xs:right-[1%]
              xs:w-[30%] xs:translate-x-[50%]
              sm:top-[12%] sm:right-[0%]
              sm:w-[31%] sm:translate-x-[52%]
              md:top-[12%] md:right-[0%]
              md:w-[31%] md:translate-x-[54%]
              lg:top-[13%] lg:w-[32%]
              lg:translate-x-[55%]
            "
            loading="eager"
            decoding="async"
            draggable="false"
          />

          {/* Bottom-left penguin */}
          <img
            src={BACKGROUND_PENGUIN_URL}
            alt=""
            aria-hidden="true"
            className="
              pointer-events-none absolute z-0
              bottom-[7%] left-[1%]
              w-[29%] min-w-[70px] max-w-[145px]
              -translate-x-[48%] rotate-[59deg] opacity-50
              xs:bottom-[7%] xs:left-[1%]
              xs:w-[30%] xs:-translate-x-[50%]
              sm:bottom-[8%] sm:left-[0%]
              sm:w-[31%] sm:-translate-x-[52%]
              md:bottom-[8%] md:left-[0%]
              md:w-[31%] md:-translate-x-[54%]
              lg:bottom-[9%] lg:w-[32%]
              lg:-translate-x-[55%]
            "
            loading="eager"
            decoding="async"
            draggable="false"
          />

          {/* Orientation video */}
          <video
            ref={videoRef}
            src={ORIENTATION_VIDEO_URL}
            controls
            playsInline
            preload="metadata"
            className="
              relative z-10 block h-auto
              w-[80%] max-h-[58dvh]
              rounded-[22px] bg-[#F5C9A8]
              object-contain
              shadow-[0_10px_30px_rgba(0,0,0,0.12)]
              xs:w-[80%] xs:max-h-[59dvh]
              sm:w-[81%] sm:max-h-[61dvh]
              sm:rounded-[24px]
              md:w-[82%] md:max-h-[63dvh]
              md:rounded-[26px]
              lg:w-[83%] lg:max-h-[65dvh]
              lg:rounded-[28px]
              xl:w-[84%] xl:max-h-[67dvh]
            "
          />
        </div>
      </div>
    </ProfileGateShell>
  );
}
